import React from 'react'

class Header extends React.Component {
    render() {
        return (
            <section id="header">
                <div className="inner">
                    <span className="icon major fas fa-brain"></span>
                    <h1>
                      NeuroFit
                    </h1>
                    <p>
                      Optimize your brain and join a connected community striving for neurological perfection through transcranial electrical stimulation.
                    </p>
                    <ul className="actions">
                      <li><a href="#one" className="button scrolly">Discover</a></li>
                    </ul>
                </div>
            </section>
        )
    }
}

export default Header
